import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30562024")

_pushScopeId("data-v-30562024")
const _hoisted_1 = { class: "table-primes" }
const _hoisted_2 = /*#__PURE__*/_createVNode("td", null, "CEE", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("td", null, " Autre(s) aide(s) ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("table", _hoisted_1, [
    _createVNode("thead", null, [
      _createVNode("td", null, _toDisplayString($setup.t('Simulation.taxBracket')), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
        return (_openBlock(), _createBlock("td", { key: taxBracket }, _toDisplayString($setup.t(`Simulation.TaxBracket.${taxBracket}`)), 1))
      }), 128))
    ]),
    _createVNode("tbody", null, [
      _createVNode("tr", null, [
        _hoisted_2,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
          return (_openBlock(), _createBlock("td", { key: taxBracket }, _toDisplayString($setup.formatEuro($props.simulation.cee[taxBracket] || 0)), 1))
        }), 128))
      ]),
      _createVNode("tr", null, [
        _hoisted_3,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
          return (_openBlock(), _createBlock("td", { key: taxBracket }, _toDisplayString($setup.formatEuro($props.simulation.otherPrime || 0)), 1))
        }), 128))
      ]),
      _createVNode("tr", null, [
        _createVNode("td", null, _toDisplayString($setup.t('Simulation.primeRenov')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
          return (_openBlock(), _createBlock("td", { key: taxBracket }, _toDisplayString($setup.formatEuro($props.simulation.renov[taxBracket] || 0)), 1))
        }), 128))
      ]),
      _createVNode("tr", null, [
        _createVNode("td", null, _toDisplayString($setup.t('Simulation.total')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
          return (_openBlock(), _createBlock("td", { key: taxBracket }, _toDisplayString($setup.formatEuro(
              ($props.simulation.cee[taxBracket] || 0) +
                ($props.simulation.renov[taxBracket] || 0) +
                ($props.simulation.otherPrime || 0),
            )), 1))
        }), 128))
      ]),
      _createVNode("tr", null, [
        _createVNode("td", null, _toDisplayString($setup.t('Simulation.resteACharge')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
          return (_openBlock(), _createBlock("td", { key: taxBracket }, _toDisplayString($setup.formatEuro(
              ($props.simulation.ttc || 0) -
                (($props.simulation.cee[taxBracket] || 0) +
                  ($props.simulation.renov[taxBracket] || 0) +
                  ($props.simulation.otherPrime || 0)),
            )), 1))
        }), 128))
      ])
    ])
  ]))
})